import React from 'react'

import Layout from '../components/layout'
import SEO from '../components/seo'
import Breadcrumb from '../components/breadcrumb'
import SectorPage from '../components/sectorPage'

const SpecializedPage = ({location}) => {
  return (
    <Layout simpleHeader={true} url="/distribution-specialisee" type="sector">
      <SEO 
        title="Classement des meilleurs sites de la distribution spécialisée"
        description="Quels sont les meilleurs sites de la distribution spécialisée de l'Observatoire de l'impact positif ? Comment se démarquent les sites de distribution spécialisée en ligne ?"
        path="/distribution-specialisee" />
      
      <Breadcrumb url="/distribution-specialisee" label="Distribution spécialisée" />

      <SectorPage slug="specialized" type="sector" />
    </Layout>
  )
  }

export default SpecializedPage

